module.exports = __webpack_public_path__ + "img/close-app.700c114c.svg";